import { AudienceAutocomplete } from './autocomplete';
import { ValueOf } from './utils';

export const moduleRestrictionMode = {
    all: 0,
    admin: 1,
    custom: 2,
} as const;

export type ModuleRestrictionModeValues = ValueOf<typeof moduleRestrictionMode>;

export type ModuleConfiguration = {
    moduleName: string;
    active: boolean;
    accessRight?: ModuleRestrictionModeValues;
    accessRightSelector?: Array<AudienceAutocomplete>;
    writeRight?: ModuleRestrictionModeValues;
    writeRightSelector?: Array<AudienceAutocomplete>;
};

export type ModuleConfigurationFields = Omit<ModuleConfiguration, 'moduleName'>;
